import React from 'react'

const CheckIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 -960 960 960"   {...props} ><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg>
  )
}

export default CheckIcon